module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-cover skin tl flex",
    class: ("skin-" + _vm.skin)
  }, [_c('cover-book', {
    staticClass: "cover w-25",
    attrs: {
      "cover": _vm.livre && _vm.livre.couverture
    }
  }), (_vm.livre) ? [_c('div', {
    staticClass: "infos flex-auto",
    staticStyle: {
      "width": "0"
    }
  }, [_c('h4', {
    staticClass: "titre b f4 mb1 gray"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.livre.titre, 38)))]), _c('h6', {
    staticClass: "subtitl auteurs f4 silver mb2"
  }, [_c('b', [_vm._v(_vm._s(_vm.auteurs))])]), _c('div', {
    staticClass: "desc content lh-copy f5",
    domProps: {
      "innerHTML": _vm._s(_vm.livre.description)
    }
  })]), _vm._t("default", null, {
    livre: _vm.livre
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4bdf2ee"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/presentation/book-cover.vue
// module id = 1366
// module chunks = 1